import { z } from 'zod';
/*
  secretConfidenceSchema is the Zod schema for validating confidence levels.
  Single source of truth for the level literals shared across settings config,
  the resolver endpoints, and the frontend badge/control.
*/
export const secretConfidenceSchema = z.enum([
    'low',
    'medium',
    'high',
]);
/*
  CONFIDENCE_ORDER provides a stable ordering for comparison.
  Higher number = more confident. Mirrors SEVERITY_ORDER so badges/labels and
  select controls can reuse the same ascending/descending logic.
*/
export const CONFIDENCE_ORDER = {
    low: 1,
    medium: 2,
    high: 3,
};
//# sourceMappingURL=secret-confidence.js.map